module.exports = __webpack_public_path__ + "img/cashposto_green.623ee665.svg";